import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import PetAdRow from './PetAdRow';

const PetAdTable = ({
  adsList,
  previewsList,
  onClearAd,
  onRowSelected,
  onUploadAd,
  selectedAd
}) => {
	const ads = adsList.map((ad) => {
    const selected = (selectedAd.petType === ad.petType) ? true : false;
    
    const adPreview = previewsList.find((preview) => {
      return preview.petType === ad.petType;
    });
    
    return (
      <PetAdRow key={ad.petType} 
                ad={ad} 
                preview={adPreview.previewUrl} 
                onClear={onClearAd} 
                onSelected={onRowSelected} 
                onUpload={onUploadAd} 
                selected={selected}/>
    );
  });

  return (
		<table className="table table-hover aspace-table">
      <thead>
        <tr>
          <th>{I18n.t('PET_TYPE')}</th>
          <th>{I18n.t('AD_UPLOADED')}</th>
          <th/>
        </tr>
      </thead>
      <tbody>
        {ads}
      </tbody>
    </table>
	);
};

PetAdTable.propTypes = {
  adsList: PropTypes.array.isRequired,
  previewsList: PropTypes.array.isRequired,
  onClearAd: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  onUploadAd: PropTypes.func.isRequired,
  selectedAd: PropTypes.object.isRequired
};

export default PetAdTable;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/PetAdTable.js
 **/